import { o as isEnvironmentLocalAndDevelopment } from "./Environment-B1ZpdxIS.js";
import { t as loggerUtils } from "./Logging-BxRsYlKX.js";
import { identity, isEmpty, pickBy } from "lodash-es";
import Cookies from "universal-cookie";
//#region ../../../node_modules/.pnpm/uuid@14.0.0/node_modules/uuid/dist/stringify.js
var byteToHex = [];
for (let i = 0; i < 256; ++i) byteToHex.push((i + 256).toString(16).slice(1));
function unsafeStringify(arr, offset = 0) {
	return (byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + "-" + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + "-" + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + "-" + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + "-" + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]]).toLowerCase();
}
//#endregion
//#region ../../../node_modules/.pnpm/uuid@14.0.0/node_modules/uuid/dist/rng.js
var rnds8 = new Uint8Array(16);
function rng() {
	return crypto.getRandomValues(rnds8);
}
//#endregion
//#region ../../../node_modules/.pnpm/uuid@14.0.0/node_modules/uuid/dist/v4.js
function v4(options, buf, offset) {
	if (!buf && !options && crypto.randomUUID) return crypto.randomUUID();
	return _v4(options, buf, offset);
}
function _v4(options, buf, offset) {
	options = options || {};
	const rnds = options.random ?? options.rng?.() ?? rng();
	if (rnds.length < 16) throw new Error("Random bytes length must be >= 16");
	rnds[6] = rnds[6] & 15 | 64;
	rnds[8] = rnds[8] & 63 | 128;
	if (buf) {
		offset = offset || 0;
		if (offset < 0 || offset + 16 > buf.length) throw new RangeError(`UUID byte range ${offset}:${offset + 15} is out of buffer bounds`);
		for (let i = 0; i < 16; ++i) buf[offset + i] = rnds[i];
		return buf;
	}
	return unsafeStringify(rnds);
}
//#endregion
//#region src/Analytics/types.ts
/**
* Tracking event type
*/
var EventType = /* @__PURE__ */ function(EventType) {
	EventType["IDENTIFY"] = "identify";
	EventType["PAGE"] = "page";
	EventType["RESET"] = "reset";
	EventType["TRACK"] = "track";
	return EventType;
}({});
//#endregion
//#region src/Analytics/Segment/segment.ts
var ANONYMOUS_IP_ADDRESS = "0.0.0.0";
var cookies = new Cookies();
var internalState = {
	sessionStart: -1,
	sessionDeviceId: ""
};
var getDeviceId = () => {
	const getDeviceIdFromLocalStorage = (localStorage) => {
		const existingDeviceId = localStorage.getItem("amplitudeDeviceId");
		if (existingDeviceId) return existingDeviceId;
		const newDeviceId = String(v4());
		localStorage.setItem("amplitudeDeviceId", newDeviceId);
		return newDeviceId;
	};
	const getDeviceIdFromMemory = () => {
		if (!internalState.sessionDeviceId) internalState.sessionDeviceId = String(v4());
		return internalState.sessionDeviceId;
	};
	let localStorage;
	try {
		localStorage = window.localStorage;
	} catch {}
	if (localStorage) return getDeviceIdFromLocalStorage(localStorage);
	return getDeviceIdFromMemory();
};
var getSegmentSessionId = () => {
	if (internalState.sessionStart < 0) internalState.sessionStart = Math.round(Date.now());
	return internalState.sessionStart;
};
var getMarketingCookies = () => {
	const data = pickBy({
		source: cookies.get("utm_source"),
		medium: cookies.get("utm_medium"),
		term: cookies.get("utm_term"),
		content: cookies.get("utm_content"),
		name: cookies.get("utm_campaign")
	}, identity);
	return isEmpty(data) ? void 0 : data;
};
/**
* Wrapper for Segment's user().traits() method, which returns the Segment user's
* persistent traits from localStorage.
*/
var getSegmentPersistentTraits = () => {
	if (typeof window.analytics === "undefined") return;
	if (typeof window.analytics.user !== "function") return;
	const user = window.analytics.user();
	if (typeof user.traits !== "function") return;
	return user.traits();
};
/**
* Gets the user's Braze ID. This is a unique identifier for the user that is added to
* email links by Braze as the bid query parameter. This function attempts to find the
* ID either in the bid query parameter or in the Segment user's persistent traits.
*/
var getBrazeId = () => {
	const brazeId = new URLSearchParams(window.location.search).get("bid");
	if (brazeId) return brazeId;
	const traits = getSegmentPersistentTraits();
	if (!traits) return;
	return traits.braze_id;
};
var getTraitsForContext = () => {
	const brazeId = getBrazeId();
	if (brazeId) return { braze_id: brazeId };
};
var getSegmentContext = () => {
	return pickBy({
		campaign: getMarketingCookies(),
		ip: ANONYMOUS_IP_ADDRESS,
		device: { id: getDeviceId() },
		traits: getTraitsForContext()
	}, identity);
};
/**
* Makes a request to Segment, if available.
*
* TODO: Define a TS type over the Segment API.
* @see https://segment.com/docs/connections/sources/catalog/libraries/website/javascript/
*/
var sendCommand = (command, ...args) => {
	if (isEnvironmentLocalAndDevelopment()) loggerUtils.logMessageToConsole("segment:", command, ...args);
	if (typeof window.analytics !== "undefined") window.analytics[command](...args);
};
/**
* Returns the properties that should be sent to Segment.
*
* <p>Augments the given properties so Segment has enough information.
* @param properties Properties that callers want to send to Segment
*/
var getSegmentProperties = (properties) => {
	return {
		...properties,
		color_session_id: getSegmentSessionId()
	};
};
/**
* Identifies the user based on their patient ID.
*
* <p>The user is identified by their patient ID because it's not considered PHI and can be used to
* correlate tracking events back to the user in the internal data warehouse.
* @param props Patient properties, including information to set Segment traits.
* @see https://getcolor.atlassian.net/browse/DATAPLAT-347
* @see https://docs.google.com/document/d/1v1r8ImmFupQX0sj0DC2oRq-qr859CUw01AvT0a-kveU
* @see https://segment.com/docs/connections/spec/identify/
*/
var identifySegmentUser = (props) => {
	const { isColorEmployee = false, patientId, properties } = props;
	const brazeId = getBrazeId();
	const segmentProperties = {
		...getSegmentProperties(properties),
		...brazeId ? { braze_id: brazeId } : {}
	};
	sendCommand(EventType.IDENTIFY, patientId, {
		is_color_employee: isColorEmployee,
		...segmentProperties
	}, { context: getSegmentContext() });
};
/**
* Resets the id, including anonymousId, and clears traits for the currently identified user and
* group.
*/
var resetSegmentUser = () => {
	sendCommand(EventType.RESET, {});
	internalState.sessionStart = -1;
	internalState.sessionDeviceId = "";
};
/**
* Logs a page view to Segment.
* @param name An optional name for the page
* @param properties An optional set of properties to include with this event
*/
var logSegmentPageView = (name, properties) => {
	sendCommand(EventType.PAGE, void 0, name, getSegmentProperties(properties), { context: getSegmentContext() });
};
/**
* Logs an event to Segment.
* @param event The event name
* @param properties An optional set of properties to include with this event,
*   describing perhaps the user who performed the event, or the event itself
*/
var trackSegmentEvent = (event, properties = {}) => {
	sendCommand(EventType.TRACK, event, getSegmentProperties(properties), { context: getSegmentContext() });
};
//#endregion
export { trackSegmentEvent as a, resetSegmentUser as i, identifySegmentUser as n, logSegmentPageView as r, getSegmentSessionId as t };

//# sourceMappingURL=segment-CWTqteLr.js.map